import { render, staticRenderFns } from "./Pessoas.vue?vue&type=template&id=2e47c0e6&scoped=true&"
import script from "./Pessoas.vue?vue&type=script&lang=js&"
export * from "./Pessoas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e47c0e6",
  null
  
)

export default component.exports